import { MessageService } from "primeng/api";
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { BarcodeFormat } from "@zxing/library";
import { BehaviorSubject, Subscription } from "rxjs";
import { ProductAuthService } from "./../../services/product-auth.service";
import { LoginService } from "src/app/services/login.service";
import {
  ProductAuthRequest,
  ProductAuthResponse,
  ProductRating,
  ProductRatingResponse,
  GetUserVerificationResponse,
  GetUserVerification,
  CustomFieldResponse,
  CustomFieldDetails,
} from "src/app/models/productAuth";
import {
  ProductMasterResponse,
  ProductMaster,
} from "../../models/Masters/productMaster";
import { DomSanitizer } from "@angular/platform-browser";
import { UserMaster } from "src/app/models/Masters/userMaster";
import { AudioRecordingService } from "src/app/services/audio-recording-service";
import { Router } from "@angular/router";

export let browserRefresh = false;

@Component({
  selector: "app-pr-auth",
  templateUrl: "./pr-auth.component.html",
  styleUrls: ["./pr-auth.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PrAuthComponent implements OnInit {
  video: any;
  selectedCountry: any;
  audioFile: any;
  isPlaying = false;
  displayControls = true;
  isAudioRecording = false;
  isVideoRecording = false;
  audioRecordedTime: any;
  audioBlobUrl: any;
  audioBlob: any;
  subscription: Subscription;
  ablob: any;
  audioName: any;
  audioStream: any;
  audioConf = { audio: true };
  MsgPopUp: string;
  productAuthRequests: ProductAuthRequest = new ProductAuthRequest();
  user: UserMaster;
  state = "smaller";
  moreData = false;
  feedbackForm: FormGroup;
  countriesWithPhoneCode = [
    {
      name: "Afghanistan",
      dial_code: "+93",
      code: "AF",
    },
    {
      name: "Aland Islands",
      dial_code: "+358",
      code: "AX",
    },
    {
      name: "Albania",
      dial_code: "+355",
      code: "AL",
    },
    {
      name: "Algeria",
      dial_code: "+213",
      code: "DZ",
    },
    {
      name: "AmericanSamoa",
      dial_code: "+1684",
      code: "AS",
    },
    {
      name: "Andorra",
      dial_code: "+376",
      code: "AD",
    },
    {
      name: "Angola",
      dial_code: "+244",
      code: "AO",
    },
    {
      name: "Anguilla",
      dial_code: "+1264",
      code: "AI",
    },
    {
      name: "Antarctica",
      dial_code: "+672",
      code: "AQ",
    },
    {
      name: "Antigua and Barbuda",
      dial_code: "+1268",
      code: "AG",
    },
    {
      name: "Argentina",
      dial_code: "+54",
      code: "AR",
    },
    {
      name: "Armenia",
      dial_code: "+374",
      code: "AM",
    },
    {
      name: "Aruba",
      dial_code: "+297",
      code: "AW",
    },
    {
      name: "Australia",
      dial_code: "+61",
      code: "AU",
    },
    {
      name: "Austria",
      dial_code: "+43",
      code: "AT",
    },
    {
      name: "Azerbaijan",
      dial_code: "+994",
      code: "AZ",
    },
    {
      name: "Bahamas",
      dial_code: "+1242",
      code: "BS",
    },
    {
      name: "Bahrain",
      dial_code: "+973",
      code: "BH",
    },
    {
      name: "Bangladesh",
      dial_code: "+880",
      code: "BD",
    },
    {
      name: "Barbados",
      dial_code: "+1246",
      code: "BB",
    },
    {
      name: "Belarus",
      dial_code: "+375",
      code: "BY",
    },
    {
      name: "Belgium",
      dial_code: "+32",
      code: "BE",
    },
    {
      name: "Belize",
      dial_code: "+501",
      code: "BZ",
    },
    {
      name: "Benin",
      dial_code: "+229",
      code: "BJ",
    },
    {
      name: "Bermuda",
      dial_code: "+1441",
      code: "BM",
    },
    {
      name: "Bhutan",
      dial_code: "+975",
      code: "BT",
    },
    {
      name: "Bolivia, Plurinational State of",
      dial_code: "+591",
      code: "BO",
    },
    {
      name: "Bosnia and Herzegovina",
      dial_code: "+387",
      code: "BA",
    },
    {
      name: "Botswana",
      dial_code: "+267",
      code: "BW",
    },
    {
      name: "Brazil",
      dial_code: "+55",
      code: "BR",
    },
    {
      name: "British Indian Ocean Territory",
      dial_code: "+246",
      code: "IO",
    },
    {
      name: "Brunei Darussalam",
      dial_code: "+673",
      code: "BN",
    },
    {
      name: "Bulgaria",
      dial_code: "+359",
      code: "BG",
    },
    {
      name: "Burkina Faso",
      dial_code: "+226",
      code: "BF",
    },
    {
      name: "Burundi",
      dial_code: "+257",
      code: "BI",
    },
    {
      name: "Cambodia",
      dial_code: "+855",
      code: "KH",
    },
    {
      name: "Cameroon",
      dial_code: "+237",
      code: "CM",
    },
    {
      name: "Canada",
      dial_code: "+1",
      code: "CA",
    },
    {
      name: "Cape Verde",
      dial_code: "+238",
      code: "CV",
    },
    {
      name: "Cayman Islands",
      dial_code: "+ 345",
      code: "KY",
    },
    {
      name: "Central African Republic",
      dial_code: "+236",
      code: "CF",
    },
    {
      name: "Chad",
      dial_code: "+235",
      code: "TD",
    },
    {
      name: "Chile",
      dial_code: "+56",
      code: "CL",
    },
    {
      name: "China",
      dial_code: "+86",
      code: "CN",
    },
    {
      name: "Christmas Island",
      dial_code: "+61",
      code: "CX",
    },
    {
      name: "Cocos (Keeling) Islands",
      dial_code: "+61",
      code: "CC",
    },
    {
      name: "Colombia",
      dial_code: "+57",
      code: "CO",
    },
    {
      name: "Comoros",
      dial_code: "+269",
      code: "KM",
    },
    {
      name: "Congo",
      dial_code: "+242",
      code: "CG",
    },
    {
      name: "Congo, The Democratic Republic of the Congo",
      dial_code: "+243",
      code: "CD",
    },
    {
      name: "Cook Islands",
      dial_code: "+682",
      code: "CK",
    },
    {
      name: "Costa Rica",
      dial_code: "+506",
      code: "CR",
    },
    {
      name: "Cote d'Ivoire",
      dial_code: "+225",
      code: "CI",
    },
    {
      name: "Croatia",
      dial_code: "+385",
      code: "HR",
    },
    {
      name: "Cuba",
      dial_code: "+53",
      code: "CU",
    },
    {
      name: "Cyprus",
      dial_code: "+357",
      code: "CY",
    },
    {
      name: "Czech Republic",
      dial_code: "+420",
      code: "CZ",
    },
    {
      name: "Denmark",
      dial_code: "+45",
      code: "DK",
    },
    {
      name: "Djibouti",
      dial_code: "+253",
      code: "DJ",
    },
    {
      name: "Dominica",
      dial_code: "+1767",
      code: "DM",
    },
    {
      name: "Dominican Republic",
      dial_code: "+1849",
      code: "DO",
    },
    {
      name: "Ecuador",
      dial_code: "+593",
      code: "EC",
    },
    {
      name: "Egypt",
      dial_code: "+20",
      code: "EG",
    },
    {
      name: "El Salvador",
      dial_code: "+503",
      code: "SV",
    },
    {
      name: "Equatorial Guinea",
      dial_code: "+240",
      code: "GQ",
    },
    {
      name: "Eritrea",
      dial_code: "+291",
      code: "ER",
    },
    {
      name: "Estonia",
      dial_code: "+372",
      code: "EE",
    },
    {
      name: "Ethiopia",
      dial_code: "+251",
      code: "ET",
    },
    {
      name: "Falkland Islands (Malvinas)",
      dial_code: "+500",
      code: "FK",
    },
    {
      name: "Faroe Islands",
      dial_code: "+298",
      code: "FO",
    },
    {
      name: "Fiji",
      dial_code: "+679",
      code: "FJ",
    },
    {
      name: "Finland",
      dial_code: "+358",
      code: "FI",
    },
    {
      name: "France",
      dial_code: "+33",
      code: "FR",
    },
    {
      name: "French Guiana",
      dial_code: "+594",
      code: "GF",
    },
    {
      name: "French Polynesia",
      dial_code: "+689",
      code: "PF",
    },
    {
      name: "Gabon",
      dial_code: "+241",
      code: "GA",
    },
    {
      name: "Gambia",
      dial_code: "+220",
      code: "GM",
    },
    {
      name: "Georgia",
      dial_code: "+995",
      code: "GE",
    },
    {
      name: "Germany",
      dial_code: "+49",
      code: "DE",
    },
    {
      name: "Ghana",
      dial_code: "+233",
      code: "GH",
    },
    {
      name: "Gibraltar",
      dial_code: "+350",
      code: "GI",
    },
    {
      name: "Greece",
      dial_code: "+30",
      code: "GR",
    },
    {
      name: "Greenland",
      dial_code: "+299",
      code: "GL",
    },
    {
      name: "Grenada",
      dial_code: "+1473",
      code: "GD",
    },
    {
      name: "Guadeloupe",
      dial_code: "+590",
      code: "GP",
    },
    {
      name: "Guam",
      dial_code: "+1671",
      code: "GU",
    },
    {
      name: "Guatemala",
      dial_code: "+502",
      code: "GT",
    },
    {
      name: "Guernsey",
      dial_code: "+44",
      code: "GG",
    },
    {
      name: "Guinea",
      dial_code: "+224",
      code: "GN",
    },
    {
      name: "Guinea-Bissau",
      dial_code: "+245",
      code: "GW",
    },
    {
      name: "Guyana",
      dial_code: "+595",
      code: "GY",
    },
    {
      name: "Haiti",
      dial_code: "+509",
      code: "HT",
    },
    {
      name: "Holy See (Vatican City State)",
      dial_code: "+379",
      code: "VA",
    },
    {
      name: "Honduras",
      dial_code: "+504",
      code: "HN",
    },
    {
      name: "Hong Kong",
      dial_code: "+852",
      code: "HK",
    },
    {
      name: "Hungary",
      dial_code: "+36",
      code: "HU",
    },
    {
      name: "Iceland",
      dial_code: "+354",
      code: "IS",
    },
    {
      name: "India",
      dial_code: "+91",
      code: "IN",
    },
    {
      name: "Indonesia",
      dial_code: "+62",
      code: "ID",
    },
    {
      name: "Iran, Islamic Republic of Persian Gulf",
      dial_code: "+98",
      code: "IR",
    },
    {
      name: "Iraq",
      dial_code: "+964",
      code: "IQ",
    },
    {
      name: "Ireland",
      dial_code: "+353",
      code: "IE",
    },
    {
      name: "Isle of Man",
      dial_code: "+44",
      code: "IM",
    },
    {
      name: "Israel",
      dial_code: "+972",
      code: "IL",
    },
    {
      name: "Italy",
      dial_code: "+39",
      code: "IT",
    },
    {
      name: "Jamaica",
      dial_code: "+1876",
      code: "JM",
    },
    {
      name: "Japan",
      dial_code: "+81",
      code: "JP",
    },
    {
      name: "Jersey",
      dial_code: "+44",
      code: "JE",
    },
    {
      name: "Jordan",
      dial_code: "+962",
      code: "JO",
    },
    {
      name: "Kazakhstan",
      dial_code: "+77",
      code: "KZ",
    },
    {
      name: "Kenya",
      dial_code: "+254",
      code: "KE",
    },
    {
      name: "Kiribati",
      dial_code: "+686",
      code: "KI",
    },
    {
      name: "Korea, Democratic People's Republic of Korea",
      dial_code: "+850",
      code: "KP",
    },
    {
      name: "Korea, Republic of South Korea",
      dial_code: "+82",
      code: "KR",
    },
    {
      name: "Kuwait",
      dial_code: "+965",
      code: "KW",
    },
    {
      name: "Kyrgyzstan",
      dial_code: "+996",
      code: "KG",
    },
    {
      name: "Laos",
      dial_code: "+856",
      code: "LA",
    },
    {
      name: "Latvia",
      dial_code: "+371",
      code: "LV",
    },
    {
      name: "Lebanon",
      dial_code: "+961",
      code: "LB",
    },
    {
      name: "Lesotho",
      dial_code: "+266",
      code: "LS",
    },
    {
      name: "Liberia",
      dial_code: "+231",
      code: "LR",
    },
    {
      name: "Libyan Arab Jamahiriya",
      dial_code: "+218",
      code: "LY",
    },
    {
      name: "Liechtenstein",
      dial_code: "+423",
      code: "LI",
    },
    {
      name: "Lithuania",
      dial_code: "+370",
      code: "LT",
    },
    {
      name: "Luxembourg",
      dial_code: "+352",
      code: "LU",
    },
    {
      name: "Macao",
      dial_code: "+853",
      code: "MO",
    },
    {
      name: "Macedonia",
      dial_code: "+389",
      code: "MK",
    },
    {
      name: "Madagascar",
      dial_code: "+261",
      code: "MG",
    },
    {
      name: "Malawi",
      dial_code: "+265",
      code: "MW",
    },
    {
      name: "Malaysia",
      dial_code: "+60",
      code: "MY",
    },
    {
      name: "Maldives",
      dial_code: "+960",
      code: "MV",
    },
    {
      name: "Mali",
      dial_code: "+223",
      code: "ML",
    },
    {
      name: "Malta",
      dial_code: "+356",
      code: "MT",
    },
    {
      name: "Marshall Islands",
      dial_code: "+692",
      code: "MH",
    },
    {
      name: "Martinique",
      dial_code: "+596",
      code: "MQ",
    },
    {
      name: "Mauritania",
      dial_code: "+222",
      code: "MR",
    },
    {
      name: "Mauritius",
      dial_code: "+230",
      code: "MU",
    },
    {
      name: "Mayotte",
      dial_code: "+262",
      code: "YT",
    },
    {
      name: "Mexico",
      dial_code: "+52",
      code: "MX",
    },
    {
      name: "Micronesia, Federated States of Micronesia",
      dial_code: "+691",
      code: "FM",
    },
    {
      name: "Moldova",
      dial_code: "+373",
      code: "MD",
    },
    {
      name: "Monaco",
      dial_code: "+377",
      code: "MC",
    },
    {
      name: "Mongolia",
      dial_code: "+976",
      code: "MN",
    },
    {
      name: "Montenegro",
      dial_code: "+382",
      code: "ME",
    },
    {
      name: "Montserrat",
      dial_code: "+1664",
      code: "MS",
    },
    {
      name: "Morocco",
      dial_code: "+212",
      code: "MA",
    },
    {
      name: "Mozambique",
      dial_code: "+258",
      code: "MZ",
    },
    {
      name: "Myanmar",
      dial_code: "+95",
      code: "MM",
    },
    {
      name: "Namibia",
      dial_code: "+264",
      code: "NA",
    },
    {
      name: "Nauru",
      dial_code: "+674",
      code: "NR",
    },
    {
      name: "Nepal",
      dial_code: "+977",
      code: "NP",
    },
    {
      name: "Netherlands",
      dial_code: "+31",
      code: "NL",
    },
    {
      name: "Netherlands Antilles",
      dial_code: "+599",
      code: "AN",
    },
    {
      name: "New Caledonia",
      dial_code: "+687",
      code: "NC",
    },
    {
      name: "New Zealand",
      dial_code: "+64",
      code: "NZ",
    },
    {
      name: "Nicaragua",
      dial_code: "+505",
      code: "NI",
    },
    {
      name: "Niger",
      dial_code: "+227",
      code: "NE",
    },
    {
      name: "Nigeria",
      dial_code: "+234",
      code: "NG",
    },
    {
      name: "Niue",
      dial_code: "+683",
      code: "NU",
    },
    {
      name: "Norfolk Island",
      dial_code: "+672",
      code: "NF",
    },
    {
      name: "Northern Mariana Islands",
      dial_code: "+1670",
      code: "MP",
    },
    {
      name: "Norway",
      dial_code: "+47",
      code: "NO",
    },
    {
      name: "Oman",
      dial_code: "+968",
      code: "OM",
    },
    {
      name: "Pakistan",
      dial_code: "+92",
      code: "PK",
    },
    {
      name: "Palau",
      dial_code: "+680",
      code: "PW",
    },
    {
      name: "Palestinian Territory, Occupied",
      dial_code: "+970",
      code: "PS",
    },
    {
      name: "Panama",
      dial_code: "+507",
      code: "PA",
    },
    {
      name: "Papua New Guinea",
      dial_code: "+675",
      code: "PG",
    },
    {
      name: "Paraguay",
      dial_code: "+595",
      code: "PY",
    },
    {
      name: "Peru",
      dial_code: "+51",
      code: "PE",
    },
    {
      name: "Philippines",
      dial_code: "+63",
      code: "PH",
    },
    {
      name: "Pitcairn",
      dial_code: "+872",
      code: "PN",
    },
    {
      name: "Poland",
      dial_code: "+48",
      code: "PL",
    },
    {
      name: "Portugal",
      dial_code: "+351",
      code: "PT",
    },
    {
      name: "Puerto Rico",
      dial_code: "+1939",
      code: "PR",
    },
    {
      name: "Qatar",
      dial_code: "+974",
      code: "QA",
    },
    {
      name: "Romania",
      dial_code: "+40",
      code: "RO",
    },
    {
      name: "Russia",
      dial_code: "+7",
      code: "RU",
    },
    {
      name: "Rwanda",
      dial_code: "+250",
      code: "RW",
    },
    {
      name: "Reunion",
      dial_code: "+262",
      code: "RE",
    },
    {
      name: "Saint Barthelemy",
      dial_code: "+590",
      code: "BL",
    },
    {
      name: "Saint Helena, Ascension and Tristan Da Cunha",
      dial_code: "+290",
      code: "SH",
    },
    {
      name: "Saint Kitts and Nevis",
      dial_code: "+1869",
      code: "KN",
    },
    {
      name: "Saint Lucia",
      dial_code: "+1758",
      code: "LC",
    },
    {
      name: "Saint Martin",
      dial_code: "+590",
      code: "MF",
    },
    {
      name: "Saint Pierre and Miquelon",
      dial_code: "+508",
      code: "PM",
    },
    {
      name: "Saint Vincent and the Grenadines",
      dial_code: "+1784",
      code: "VC",
    },
    {
      name: "Samoa",
      dial_code: "+685",
      code: "WS",
    },
    {
      name: "San Marino",
      dial_code: "+378",
      code: "SM",
    },
    {
      name: "Sao Tome and Principe",
      dial_code: "+239",
      code: "ST",
    },
    {
      name: "Saudi Arabia",
      dial_code: "+966",
      code: "SA",
    },
    {
      name: "Senegal",
      dial_code: "+221",
      code: "SN",
    },
    {
      name: "Serbia",
      dial_code: "+381",
      code: "RS",
    },
    {
      name: "Seychelles",
      dial_code: "+248",
      code: "SC",
    },
    {
      name: "Sierra Leone",
      dial_code: "+232",
      code: "SL",
    },
    {
      name: "Singapore",
      dial_code: "+65",
      code: "SG",
    },
    {
      name: "Slovakia",
      dial_code: "+421",
      code: "SK",
    },
    {
      name: "Slovenia",
      dial_code: "+386",
      code: "SI",
    },
    {
      name: "Solomon Islands",
      dial_code: "+677",
      code: "SB",
    },
    {
      name: "Somalia",
      dial_code: "+252",
      code: "SO",
    },
    {
      name: "South Africa",
      dial_code: "+27",
      code: "ZA",
    },
    {
      name: "South Sudan",
      dial_code: "+211",
      code: "SS",
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      dial_code: "+500",
      code: "GS",
    },
    {
      name: "Spain",
      dial_code: "+34",
      code: "ES",
    },
    {
      name: "Sri Lanka",
      dial_code: "+94",
      code: "LK",
    },
    {
      name: "Sudan",
      dial_code: "+249",
      code: "SD",
    },
    {
      name: "Suriname",
      dial_code: "+597",
      code: "SR",
    },
    {
      name: "Svalbard and Jan Mayen",
      dial_code: "+47",
      code: "SJ",
    },
    {
      name: "Swaziland",
      dial_code: "+268",
      code: "SZ",
    },
    {
      name: "Sweden",
      dial_code: "+46",
      code: "SE",
    },
    {
      name: "Switzerland",
      dial_code: "+41",
      code: "CH",
    },
    {
      name: "Syrian Arab Republic",
      dial_code: "+963",
      code: "SY",
    },
    {
      name: "Taiwan",
      dial_code: "+886",
      code: "TW",
    },
    {
      name: "Tajikistan",
      dial_code: "+992",
      code: "TJ",
    },
    {
      name: "Tanzania, United Republic of Tanzania",
      dial_code: "+255",
      code: "TZ",
    },
    {
      name: "Thailand",
      dial_code: "+66",
      code: "TH",
    },
    {
      name: "Timor-Leste",
      dial_code: "+670",
      code: "TL",
    },
    {
      name: "Togo",
      dial_code: "+228",
      code: "TG",
    },
    {
      name: "Tokelau",
      dial_code: "+690",
      code: "TK",
    },
    {
      name: "Tonga",
      dial_code: "+676",
      code: "TO",
    },
    {
      name: "Trinidad and Tobago",
      dial_code: "+1868",
      code: "TT",
    },
    {
      name: "Tunisia",
      dial_code: "+216",
      code: "TN",
    },
    {
      name: "Turkey",
      dial_code: "+90",
      code: "TR",
    },
    {
      name: "Turkmenistan",
      dial_code: "+993",
      code: "TM",
    },
    {
      name: "Turks and Caicos Islands",
      dial_code: "+1649",
      code: "TC",
    },
    {
      name: "Tuvalu",
      dial_code: "+688",
      code: "TV",
    },
    {
      name: "Uganda",
      dial_code: "+256",
      code: "UG",
    },
    {
      name: "Ukraine",
      dial_code: "+380",
      code: "UA",
    },
    {
      name: "United Arab Emirates",
      dial_code: "+971",
      code: "AE",
    },
    {
      name: "United Kingdom",
      dial_code: "+44",
      code: "GB",
    },
    {
      name: "United States",
      dial_code: "+1",
      code: "US",
    },
    {
      name: "Uruguay",
      dial_code: "+598",
      code: "UY",
    },
    {
      name: "Uzbekistan",
      dial_code: "+998",
      code: "UZ",
    },
    {
      name: "Vanuatu",
      dial_code: "+678",
      code: "VU",
    },
    {
      name: "Venezuela, Bolivarian Republic of Venezuela",
      dial_code: "+58",
      code: "VE",
    },
    {
      name: "Vietnam",
      dial_code: "+84",
      code: "VN",
    },
    {
      name: "Virgin Islands, British",
      dial_code: "+1284",
      code: "VG",
    },
    {
      name: "Virgin Islands, U.S.",
      dial_code: "+1340",
      code: "VI",
    },
    {
      name: "Wallis and Futuna",
      dial_code: "+681",
      code: "WF",
    },
    {
      name: "Yemen",
      dial_code: "+967",
      code: "YE",
    },
    {
      name: "Zambia",
      dial_code: "+260",
      code: "ZM",
    },
    {
      name: "Zimbabwe",
      dial_code: "+263",
      code: "ZW",
    },
  ];
  ratingDisabled = false;
  recommendedItem = false;
  mobileReg: RegExp = /^([6-9]\d{9}|1[3-9]\d{9})$/;
  mobileRegInd: RegExp = /^([6-9]\d{9})$/;
  mobileRegChina: RegExp = /^(1[3-9]\d{9})$/;
  mobileRegOther: RegExp = /^([1-9]{1}\d{6,14})$/;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  ratingbox = false;
  status = false;
  submitted = false;
  isModalShown: boolean;
  installMessage = false;
  scanWraper = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ];
  hasDevices: boolean;
  hasPermission: boolean;
  showVerficationHistory = false;
  qrResultString: string;
  prodDetails: ProductAuthResponse = new ProductAuthResponse();
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;
  isAndroid = true;

  selectedCountryCode: string = "";
  countries = [
    { name: "(+91) India", code: "+91" },
    { name: "(+86) China", code: "+86" },
    { name: "(+1) United States", code: "+1" },
    { name: "(+44) United Kingdom", code: "+44" },
    { name: "(+1) Canada", code: "+1" },
    { name: "(+213) Algeria", code: "+213" },
    { name: "(+376) Andorra", code: "+376" },
    { name: "(+244) Angola", code: "+244" },
    { name: "(+54) Argentina", code: "+54" },
    { name: "(+61) Australia", code: "+61" },
    { name: "(+43) Austria", code: "+43" },
    { name: "(+880) Bangladesh", code: "+880" },
    { name: "(+32) Belgium", code: "+32" },
    { name: "(+55) Brazil", code: "+55" },
    { name: "(+57) Colombia", code: "+57" },
    { name: "(+20) Egypt", code: "+20" },
    { name: "(+33) France", code: "+33" },
    { name: "(+49) Germany", code: "+49" },
    { name: "(+62) Indonesia", code: "+62" },
    { name: "(+81) Japan", code: "+81" },
    { name: "(+254) Kenya", code: "+254" },
    { name: "(+82) South Korea", code: "+82" },
    { name: "(+965) Kuwait", code: "+965" },
    { name: "(+961) Lebanon", code: "+961" },
    { name: "(+60) Malaysia", code: "+60" },
    { name: "(+52) Mexico", code: "+52" },
    { name: "(+212) Morocco", code: "+212" },
    { name: "(+64) New Zealand", code: "+64" },
    { name: "(+234) Nigeria", code: "+234" },
    { name: "(+92) Pakistan", code: "+92" },
    { name: "(+63) Philippines", code: "+63" },
    { name: "(+48) Poland", code: "+48" },
    { name: "(+7) Russia", code: "+7" },
    { name: "(+966) Saudi Arabia", code: "+966" },
    { name: "(+65) Singapore", code: "+65" },
    { name: "(+27) South Africa", code: "+27" },
    { name: "(+34) Spain", code: "+34" },
    { name: "(+94) Sri Lanka", code: "+94" },
    { name: "(+46) Sweden", code: "+46" },
    { name: "(+41) Switzerland", code: "+41" },
    { name: "(+66) Thailand", code: "+66" },
    { name: "(+90) Turkey", code: "+90" },
    { name: "(+380) Ukraine", code: "+380" },
  ];

  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dot: true,
    // "autoplay":true,
    // "autoplaySpeed":1500,
    arrows: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // centerMode: true,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  slideConfig2 = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dot: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    centerMode: false,
  };
  event: any;
  askScratchList: CustomFieldDetails[] = [];
  askDetailsList: CustomFieldDetails[] = [];
  feedbackList: CustomFieldDetails[] = [];
  fakeFeedbackList: CustomFieldDetails[] = [];
  isNavigate = false;
  recommendedProducts: ProductMaster[] = [];
  totalRecommendedProducts: number;
  @Input() askDetailForm: FormGroup;
  @Input() askScratchCdForm: FormGroup;
  @Input() askDetailssubmitted = false;
  @Input() askScratchCdsubmitted = false;
  isAskDetailsModalShown = false;
  isAskScratchModalShown = false;
  isFakeFeedbackModalShown: boolean;
  fakeFeedbackForm: FormGroup;
  fakeFeedbackImage: any;
  cmpName: any;
  compId: any;
  isFakeFeedbackSubmitted: boolean;
  verificationHistory: GetUserVerification[];
  audioSrc: any;
  companyList: any[] = [];
  companyFilterList: any[] = [];
  askDetailCompanyAutofill: boolean = false;
  showratingbox() {
    this.ratingbox = !this.ratingbox;
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private loginService: LoginService,
    private prodAuthService: ProductAuthService,
    public sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    private audioRecordingService: AudioRecordingService,
  ) {
    this.getCompanyList();

    // this.feedbackForm = this.fb.group({
    //   usrName: [null, Validators.required],
    //   verificationId: [0],
    //   mobNo: [null, [Validators.required, Validators.pattern(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/)]],
    //   email: [null, [Validators.required]],
    //   usrFeedback: [null, [Validators.required]]
    // });

    // this.askDetailForm = this.fb.group({
    //   cmpName: [null, Validators.required],
    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    // });

    //<scratch Start>

    // this.askScratchCdForm = this.fb.group({
    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    //   scratchCd: [null, Validators.required],
    // });

    //<scratch End>

    // this.fakeFeedbackForm = this.fb.group({

    //   usrName: [null, Validators.required],
    //   email: [null],
    //   mobNo: [null, Validators.required],
    //   verImg: [null],
    //   purchasedFrm: [null],
    //   usrFeedback: [null, Validators.required],
    // });

    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;
      this.ref.detectChanges();
    });
    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;
      this.ref.detectChanges();
    });
    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.audioBlob = data.blob;
      this.audioName = data.title;
      this.ablob = new Blob([this.audioBlob], { type: "audio/mp3" });
      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob),
      );
      this.ref.detectChanges();
    });
  }

  ngOnInit() {
    var backFromRedemption = parseInt(
      JSON.parse(sessionStorage.getItem("backFromRedemption")),
    );

    var productDetails = sessionStorage.getItem("prodDetails");
    if (productDetails && backFromRedemption == 1) {
      sessionStorage.setItem("backFromRedemption", "0");
      this.prodDetails = JSON.parse(productDetails);
      if (parseInt(JSON.parse(sessionStorage.getItem("tranComplete")))) {
        this.prodDetails.data.isTransfer = "0";
        this.prodDetails.data.isShowLoyalty = "0";
        this.prodDetails.data.isLoyalty = "0";
      }
    } else {
      this.productAuthRequests.verificationMode = "Web";
      this.productAuthRequests.qrData = window.location.href;
      // this.productAuthRequests.qrData = 'http://www.sureassure.com/pa?uid=R98N1*C-SkL9uyDu0o2qNA';
      this.productAuthRequests.verificationType = 2;
      this.findMe(); // find location
      this.getMobileOperatingSystem();
    }
  }

  startAudioRecording() {
    if (!this.isAudioRecording) {
      this.isAudioRecording = true;
      this.audioRecordingService.startRecording();
    }
  }
  abortAudioRecording() {
    if (this.isAudioRecording) {
      this.isAudioRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }
  stopAudioRecording() {
    if (this.isAudioRecording) {
      this.audioRecordingService.stopRecording();
      this.isAudioRecording = false;
    }
  }
  clearAudioRecordedData() {
    this.audioBlobUrl = null;
  }
  downloadAudioRecordedData() {
    this._downloadFile(this.audioBlob, "audio/mp3", this.audioName);
  }
  ngOnDestroy(): void {
    this.abortAudioRecording();
  }
  _downloadFile(data: any, type: string, filename: string): any {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    //this.video.srcObject = stream;
    //const url = data;
    const anchor = document.createElement("a");
    anchor.download = filename;
    anchor.href = url;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  updateMobileNumberValidator(form: FormGroup): void {
    if (form.contains("mobNo")) {
      const mobNoControl = form.get("mobNo");
      if (mobNoControl) {
        mobNoControl.setValidators([
          Validators.required,
          Validators.pattern(this.getMobilePattern(form)),
        ]);
        mobNoControl.updateValueAndValidity();
      }
    }
  }

  getMobilePattern(form: FormGroup): RegExp {
    if (form && form.contains("countryCode")) {
      const countryControl = form && form.get("countryCode");
      const countryCode =
        countryControl && countryControl.value && countryControl.value.code;

      if (countryCode === "+91") return this.mobileRegInd;
      if (countryCode === "+86") return this.mobileRegChina;
      return this.mobileRegOther;
    } else {
      return this.mobileRegInd;
    }
  }

  getCustomFieldDetails(resdata: ProductAuthResponse) {
    const companyId =
      resdata.data.compId != undefined ? resdata.data.compId : 0;
    this.prodAuthService
      .getCustomFieldDetails(companyId)
      .subscribe((Response: CustomFieldResponse) => {
        const data = Response.details;

        if (data && data.length > 0) {
          const askScratchList = data.filter(
            (x) => x.pageName === "askScratchCdForm",
          );
          if (
            askScratchList &&
            askScratchList.length > 0 &&
            askScratchList[0].fieldDetails &&
            askScratchList[0].fieldDetails.length > 0
          ) {
            this.askScratchList = askScratchList[0].fieldDetails.filter(
              (x) => x.isHide === false,
            );
            var isMobile = 0;
            isMobile = this.askScratchList.findIndex((x) => {
              return x.displayName === "Mobile No";
            });
            var isPaytm =
              resdata.responseMessage == null || resdata.responseMessage == ""
                ? false
                : true;
            if (isMobile != 0 && resdata.responseCode == "-44" && isPaytm) {
              this.askScratchList[isMobile].displayName =
                "Paytm " + this.askScratchList[isMobile].displayName;
            }

            if (this.askScratchList && this.askScratchList.length > 0) {
              const formGroup = {};

              this.askScratchList.forEach((formControl) => {
                // Initialize with proper validators
                if (formControl.fieldName === "mobNo") {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate
                      ? [
                          Validators.required,
                          Validators.pattern(
                            this.getMobilePattern(this.askScratchCdForm),
                          ),
                        ]
                      : null,
                  );
                } else if (formControl.fieldName === "countryCode") {
                  // Initialize countryCode with first country selected
                  formGroup[formControl.fieldName] = new FormControl(
                    this.countries[0],
                    formControl.isValidate ? Validators.required : null,
                  );
                } else {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate ? Validators.required : null,
                  );
                }
              });

              this.askScratchCdForm = new FormGroup(formGroup);
            }

            // Add value change listener for countryCode
            if (this.askScratchCdForm.contains("countryCode")) {
              this.askScratchCdForm
                .get("countryCode")
                .valueChanges.subscribe(() => {
                  this.updateMobileNumberValidator(this.askScratchCdForm);
                });
            }
          }

          const askDetailsList = data.filter(
            (x) => x.pageName === "askDetailForm",
          );
          if (
            askDetailsList &&
            askDetailsList.length > 0 &&
            askDetailsList[0].fieldDetails &&
            askDetailsList[0].fieldDetails.length > 0
          ) {
            this.askDetailsList = askDetailsList[0].fieldDetails.filter(
              (x) => x.isHide === false,
            );
            var isMobile = 0;
            isMobile = this.askDetailsList.findIndex((x) => {
              return x.displayName === "Mobile No";
            });
            var isPaytm =
              resdata.responseMessage == null || resdata.responseMessage == ""
                ? false
                : true;
            if (isMobile != 0 && resdata.responseCode == "-3" && isPaytm) {
              this.askDetailsList[isMobile].displayName =
                "Paytm " + this.askDetailsList[isMobile].displayName;
            }
            if (this.askDetailsList && this.askDetailsList.length > 0) {
              const formGroup = {};
              this.askDetailsList.forEach((formControl) => {
                // Initialize with proper validators
                if (formControl.fieldName === "mobNo") {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate
                      ? [
                          Validators.required,
                          Validators.pattern(
                            this.getMobilePattern(this.askDetailForm),
                          ),
                        ]
                      : null,
                  );
                } else if (formControl.fieldName === "countryCode") {
                  // Initialize countryCode with first country selected
                  formGroup[formControl.fieldName] = new FormControl(
                    this.countries[0],
                    formControl.isValidate ? Validators.required : null,
                  );
                } else {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate ? Validators.required : null,
                  );
                }
              });

              this.askDetailForm = new FormGroup(formGroup);

              // Add value change listener for countryCode
              if (this.askDetailForm.contains("countryCode")) {
                this.askDetailForm
                  .get("countryCode")
                  .valueChanges.subscribe(() => {
                    this.updateMobileNumberValidator(this.askDetailForm);
                  });
              }

              if (this.askDetailForm.contains("cmpName")) {
                if (
                  resdata.data.compId != "" &&
                  resdata.data.compId != undefined
                ) {
                  this.companyFilterList = this.companyList.filter(
                    (x) => x.compId == resdata.data.compId,
                  );

                  if (this.companyFilterList.length > 0) {
                    this.askDetailForm.patchValue({
                      cmpName: this.companyFilterList[0],
                    });
                    this.askDetailCompanyAutofill = true;
                  }
                }
              }
            }
          } // Closing brace for askDetailsList block

          const feedbackList = data.filter(
            (x) => x.pageName === "feedbackForm",
          );
          if (
            feedbackList &&
            feedbackList.length > 0 &&
            feedbackList[0].fieldDetails &&
            feedbackList[0].fieldDetails.length > 0
          ) {
            this.feedbackList = feedbackList[0].fieldDetails.filter(
              (x) => x.isHide === false,
            );
            if (this.feedbackList && this.feedbackList.length > 0) {
              const formGroup = {};
              this.feedbackList.forEach((formControl) => {
                // Initialize with proper validators
                if (formControl.fieldName === "mobNo") {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate
                      ? [
                          Validators.required,
                          Validators.pattern(
                            this.getMobilePattern(this.feedbackForm),
                          ),
                        ]
                      : null,
                  );
                } else if (formControl.fieldName === "countryCode") {
                  // Initialize countryCode with first country selected
                  formGroup[formControl.fieldName] = new FormControl(
                    this.countries[0],
                    formControl.isValidate ? Validators.required : null,
                  );
                } else {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate ? Validators.required : null,
                  );
                }
              });

              this.feedbackForm = new FormGroup(formGroup);
            }

            // Add value change listener for countryCode
            if (this.feedbackForm.contains("countryCode")) {
              this.feedbackForm
                .get("countryCode")
                .valueChanges.subscribe(() => {
                  this.updateMobileNumberValidator(this.feedbackForm);
                });
            }
          }

          const fakeFeedbackList = data.filter(
            (x) => x.pageName === "fakeFeedbackForm",
          );
          if (
            fakeFeedbackList &&
            fakeFeedbackList.length > 0 &&
            fakeFeedbackList[0].fieldDetails &&
            fakeFeedbackList[0].fieldDetails.length > 0
          ) {
            this.fakeFeedbackList = fakeFeedbackList[0].fieldDetails.filter(
              (x) => x.isHide === false,
            );

            if (this.fakeFeedbackList && this.fakeFeedbackList.length > 0) {
              const formGroup = {};
              this.fakeFeedbackList.forEach((formControl) => {
                // Initialize with proper validators
                if (formControl.fieldName === "mobNo") {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate
                      ? [
                          Validators.required,
                          Validators.pattern(
                            this.getMobilePattern(this.fakeFeedbackForm),
                          ),
                        ]
                      : null,
                  );
                } else if (formControl.fieldName === "countryCode") {
                  // Initialize countryCode with first country selected
                  formGroup[formControl.fieldName] = new FormControl(
                    this.countries[0],
                    formControl.isValidate ? Validators.required : null,
                  );
                } else {
                  formGroup[formControl.fieldName] = new FormControl(
                    "",
                    formControl.isValidate ? Validators.required : null,
                  );
                }
              });

              this.fakeFeedbackForm = new FormGroup(formGroup);
            }

            // Add value change listener for countryCode
            if (this.fakeFeedbackForm.contains("countryCode")) {
              this.fakeFeedbackForm
                .get("countryCode")
                .valueChanges.subscribe(() => {
                  this.updateMobileNumberValidator(this.fakeFeedbackForm);
                });
            }
          }
        }

        if (resdata.responseCode === "-3" || (resdata.responseCode === "444" && this.askDetailCompanyAutofill == false)) {
          if (resdata.data.compId != "" && resdata.data.compId != undefined) {
            this.companyFilterList = this.companyList.filter(
              (x) => x.compId == resdata.data.compId,
            );

            if (this.companyFilterList.length > 0) {
              this.askDetailForm.patchValue({
                cmpName: this.companyFilterList[0],
              });
              this.askDetailCompanyAutofill = true;
            }
          }
        }
      });
  }

  sendProductAuthData(value: any) {
    //console.log(value);
    this.prodAuthService.productAuthData(value).subscribe(
      (productAuthResponse: ProductAuthResponse) => {
        this.getCustomFieldDetails(productAuthResponse);
        if (productAuthResponse.responseCode === "-1") {
          productAuthResponse.data.genuineAudio =
            productAuthResponse.data.genuineAudio == null
              ? "assets/audio/fake.mp3"
              : productAuthResponse.data.genuineAudio;
        }
        if (productAuthResponse.responseCode === "118") {
          var qrcode = this.parse_query_string(window.location.href);
          window.location.href = `http://auth.secfans.in/pa?uid=${qrcode}`;
          return;
        }
        if (productAuthResponse.responseCode === "183") {
          var qrcode = this.parse_query_string(window.location.href);
          window.location.href = `https://discover.knauf.com/en-in/gy/product-authentication`;
          return;
        }
        if (productAuthResponse.responseCode === "125") {
          window.location.href = `https://shaktivardhakhspl.com/package-qr-code-scanner/?utm_source=QRCode&utm_medium=Packet`;
          return;
        }
        if (productAuthResponse.data.prefix === "BW") {
          var qrcode = this.parse_query_string(window.location.href);
          localStorage.setItem(
            "BharatBiriData",
            JSON.stringify(productAuthResponse),
          );
          window.location.href = window.location.origin + `/bharat-biri-auth`;
          return;
        }
        // if (productAuthResponse.responseCode === "444") {
        //   var qrcode = this.parse_query_string(window.location.href);
        //   localStorage.setItem(
        //     "IssueData",
        //     JSON.stringify(productAuthResponse),
        //   );
        //   window.location.href = window.location.origin + `/pai?uid=${qrcode}`;
        //   return;
        // }
        if (productAuthResponse.responseCode === "-3" || (productAuthResponse.responseCode === "444" && this.askDetailCompanyAutofill == false)) {
          // if (productAuthResponse.data.compId != "" && productAuthResponse.data.compId != undefined) {
          //   this.companyFilterList = this.companyList.filter(x => x.compId == productAuthResponse.data.compId);
          //   this.askDetailForm.patchValue({
          //     cmpName: this.companyFilterList[0]
          //   });
          //   this.askDetailCompanyAutofill = true;
          // }

          this.MsgPopUp = productAuthResponse.responseMessage;

          this.isAskDetailsModalShown = true;
          return;
        }

        if (productAuthResponse.responseCode === "-44") {
          this.MsgPopUp = productAuthResponse.responseMessage;
          this.isAskScratchModalShown = true;
          return;
        }

        //this.audioSrc = this.sanitizer.bypassSecurityTrustResourceUrl(productAuthResponse.data.genuineAudio);
        this.prodDetails = productAuthResponse;
        // console.log(this.prodDetails);
        if (productAuthResponse.responseCode === "200" || productAuthResponse.responseCode === "444") {
          const verificationHistories = localStorage.verificationHistories
            ? JSON.parse(localStorage.verificationHistories)
            : [];
          verificationHistories.push({
            verificationId: this.prodDetails.data.verificationId,
            usrId: this.loginService.user(),
          });
          localStorage.verificationHistories = JSON.stringify(
            verificationHistories,
          );
          // this.prodDetails = productAuthResponse;
          // this.prodDetails = Array.of(this.prodDetails);
        } else {
          // this.messageService.add({ severity: 'error', summary: 'Oops', detail: productAuthResponse });
        }
      },
      (err) => {},
    );
  }

  ratingform(event: any) {
    const rate: ProductRating = {
      ratingId: 0,
      compId: this.prodDetails.data.compId,
      productId: this.prodDetails.data.productId,
      proRating: event.value,
      totalRatingCount: null,
      updatedBy: null,
      updatedDt: null,
      verificationId: this.prodDetails.data.verificationId,
    };
    this.saveRating(rate);
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor; //|| window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      //&& !window.MSStream) {
      this.isAndroid = false;
      return "iOS";
    }
    if (/windows/i.test(userAgent)) {
      return "Web";
    }
    return "unknown";
  }

  saveRating(rate: ProductRating): any {
    this.prodAuthService.saveRating(rate).subscribe(
      (resp: ProductRatingResponse) => {
        // console.log(this.prodDetails);
        if (resp.responseCode === "200") {
          this.ratingDisabled = true;
          this.prodDetails.data.productRating = resp.data.proRating;
          this.prodDetails.data.totalRating = resp.data.totalRatingCount;
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Oops",
            detail: resp.responseMessage,
          });
        }
      },
      (err) => {},
    );
  }

  search(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.companyList.length; i++) {
      let obj = this.companyList[i];
      if (obj.compNm.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(obj);
      }
    }
    this.companyFilterList = filtered;
  }
  getCompanyList(): any {
    this.prodAuthService.loadCompaniesDDL().subscribe(
      (resp: any) => {
        if (resp.responseCode === "200") {
          this.companyList = resp.details;
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Oops",
            detail: resp.responseMessage,
          });
        }
      },
      (err) => {},
    );
  }

  more() {
    this.moreData = !this.moreData;
  }
getSpecValue(key: string): string {
  if (
    this.prodDetails &&
    this.prodDetails.data &&
    this.prodDetails.data.prodSpecification
  ) {
    const item = this.prodDetails.data.prodSpecification.find(
      (x: any) => x.key === key
    );
    return item ? item.value : '';
  }
  return '';
}
  showModal(): void {
    this.isModalShown = true;
    this.clearAudioRecordedData();
  }
  seeAll() {
    const obj = {
      pageSize: -1,
      compId: this.prodDetails.data.compId,
    };
    this.getLazyLoadProducts(obj);
    this.state = "larger";
    this.recommendedItem = true;
  }
  closeBar() {
    this.installMessage = true;
  }
  hideInfo() {
    this.state = "smaller";
    this.recommendedItem = false;
  }
  get f() {
    return this.feedbackForm.controls;
  }

  get fdetails() {
    return this.askDetailForm.controls;
  }

  get sdetails() {
    return this.askScratchCdForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.feedbackForm.invalid) {
      return;
    }

    if (this.feedbackForm.valid) {
      if (this.ablob !== null && this.ablob !== undefined) {
        var audForm = new FormData();
        var fileOfBlob = new File([this.ablob], this.audioName);
        audForm.append("file", fileOfBlob);
        this.prodAuthService.uploadAudio(audForm).subscribe(
          (resp) => {
            if (resp.responseCode === "200") {
              this.feedbackForm.addControl(
                "audioFeedback",
                new FormControl(resp.source),
              );
              const form = { ...this.feedbackForm.value };
              form.verificationId = this.prodDetails.data.verificationId;
              this.saveFeedback(form);
            } else {
            }
          },
          (err) => {},
        );
      } else {
        const form = { ...this.feedbackForm.value };
        form.verificationId = this.prodDetails.data.verificationId;
        this.saveFeedback(form);
      }
    }
  }

  onSubmitAskDetails() {
    this.askDetailssubmitted = true;
    if (this.askDetailForm.invalid) {
      return;
    }

    const form = this.askDetailForm.value;

    // Handle mobile number formatting

    if (form.mobNo) {
      const countryCode = (form.countryCode && form.countryCode.code) || "+91";
      this.productAuthRequests.mobNo = `(${countryCode})${form.mobNo}`;
    } else {
      this.productAuthRequests.mobNo = null;
    }
    this.productAuthRequests.verifiedBy = form.usrName;
    this.productAuthRequests.usrname = form.usrName;
    this.productAuthRequests.askCompId = form.cmpName && form.cmpName.compId;
    this.productAuthRequests.compId = form.cmpName && form.cmpName.compId;
    this.productAuthRequests.askForDetailsFilled = true;
    this.productAuthRequests.email = form.email;

    this.sendProductAuthData(this.productAuthRequests);
    this.onHiddenAskForm();
  }
  //<scratch on submit>
  onSubmitAskScratch() {
    this.askScratchCdsubmitted = true;

    if (this.askScratchCdForm.invalid) {
      return;
    }
    const form = { ...this.askScratchCdForm.value };
    this.productAuthRequests.mobNo = form.mobNo;
    this.productAuthRequests.verifiedBy = form.usrName;
    this.productAuthRequests.usrname = form.usrName;
    this.productAuthRequests.scratchCd = form.scratchCd;
    this.productAuthRequests.askForScratchFilled = true;
    //this.productAuthRequests.compId = form.cmpName.compId;
    this.productAuthRequests.email = form.email;
    this.sendProductAuthData(this.productAuthRequests);
    this.onHiddenAskScratch();
  }
  //<scratch on submit>

  saveFeedback(form: any) {
    this.prodAuthService.saveFeedback(form).subscribe(
      (resp: ProductAuthResponse) => {
        if (resp.responseCode === "200") {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: resp.responseMessage,
          });
          this.onHidden();
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Oops",
            detail: resp.responseMessage,
          });
        }
      },
      (err) => {},
    );
  }

  onHidden(): void {
    this.resetFeedbackForm();
    this.isModalShown = false;
  }
  handleAddRole() {
    this.showModal();
  }
  clearResult(): void {
    this.qrResultString = null;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find((x) => x.deviceId === selected);
    this.currentDevice = device || null;
  }
  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  onTorchCompatible(isCompatible: boolean): void {
    // this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  slickInit(event) {}
  breakpoint(event) {}
  afterChange(event) {}
  beforeChange(event) {}
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.showPosition(position);
        },
        (denied) => {
          // alert(JSON.stringify(denied));
          this.sendProductAuthData(this.productAuthRequests);
        },
        { enableHighAccuracy: true, maximumAge: 10000 },
      );
    } else {
      this.sendProductAuthData(this.productAuthRequests);
    }
  }
  showPosition(position) {
    this.productAuthRequests.usrlatitude = position.coords.latitude;
    this.productAuthRequests.usrlongitude = position.coords.longitude;
    this.reverseGeocodeLatLngAndVerifyProduct();
  }
  reverseGeocodeLatLngAndVerifyProduct(): any {
    // tslint:disable-next-line: max-line-length
    this.prodAuthService
      .reverseGeoCode(
        this.productAuthRequests.usrlatitude,
        this.productAuthRequests.usrlongitude,
      )
      .subscribe(
        (response: any) => {
          this.productAuthRequests.usrAdrs = response.display_name;
          this.productAuthRequests.usrCntry =
            response.address.country +
            "(" +
            this.getCountryCode(response.address.country_code) +
            ")";
          this.productAuthRequests.usrState = response.address.state;
          this.productAuthRequests.usrZip = response.address.postcode;
          this.sendProductAuthData(this.productAuthRequests);
        },
        (error) => {
          // alert(JSON.stringify(error))
          this.sendProductAuthData(this.productAuthRequests);
        },
      );
  }

  getCountryCode(code) {
    for (const item of this.countriesWithPhoneCode) {
      if (item.code.toUpperCase() == code.toUpperCase()) return item.dial_code;
    }
  }

  getLazyLoadingValues(event: any): any {
    const obj = {
      first: event.first + 1,
      searchValue: event.globalFilter ? event.globalFilter : "",
      multiSortMeta: event.multiSortMeta,
      pageSize: event.rows,
      sortColumn: event.sortField,
      sortOrder: event.sortOrder === 1 ? "ASC" : "DESC",
      isActive: "%",
      compId: this.user.compId,
    };
    return obj;
  }
  getLazyLoadProducts(event: any): any {
    this.prodAuthService.getAllSimilarProducts(event).subscribe(
      (response: ProductMasterResponse) => {
        if (response.responseCode === "200") {
          this.recommendedProducts = response.details;
          this.totalRecommendedProducts = response.totalRows;
          this.recommendedProducts = this.recommendedProducts.slice();
        } else {
        }
      },
      (err) => {},
    );
  }
  rowTrackBy(index, item) {
    return item.productId;
  }
  onHiddenAskForm() {
    this.isAskDetailsModalShown = false;
  }
  onHiddenAskScratch() {
    this.isAskScratchModalShown = false;
  }
  onHiddenFakeFeedbackForm() {
    this.resetFakeFeedbackForm();
    this.isFakeFeedbackModalShown = false;
  }
  showFakeFeedbackForm() {
    this.isFakeFeedbackModalShown = true;
    this.clearAudioRecordedData();
  }
  onSubmitFakeFeedback() {
    this.isFakeFeedbackSubmitted = true;
    if (this.fakeFeedbackForm.invalid) {
      return;
    }
    const formData = new FormData();
    formData.append("verificationId", this.prodDetails.data.verificationId);
    formData.append("verImg", this.fakeFeedbackImage);
    formData.append("email", this.fakeFeedbackForm.value.email);
    formData.append("countryCode", this.fakeFeedbackForm.value.countryCode);
    formData.append("mobNo", this.fakeFeedbackForm.value.mobNo);
    formData.append("usrName", this.fakeFeedbackForm.value.usrName);

    formData.append("cmpName", this.fakeFeedbackForm.value.cmpName);

    formData.append("purchasedFrm", this.fakeFeedbackForm.value.purchasedFrm);
    formData.append("usrFeedback", this.fakeFeedbackForm.value.usrFeedback);
    var audioFeedback = "";
    if (this.ablob !== null && this.ablob !== undefined) {
      var audForm = new FormData();
      var fileOfBlob = new File([this.ablob], this.audioName);
      audForm.append("file", fileOfBlob);
      this.prodAuthService.uploadAudio(audForm).subscribe(
        (resp) => {
          if (resp.responseCode === "200") {
            audioFeedback = resp.source;
            formData.append("audioFeedback", audioFeedback);
            this.feedBackOnFakeVerification(formData);
          } else {
          }
        },
        (err) => {},
      );
    } else {
      formData.append("audioFeedback", audioFeedback);
      this.feedBackOnFakeVerification(formData);
    }
  }
  feedBackOnFakeVerification(formData: FormData) {
    this.prodAuthService.feedBackOnFakeVerification(formData).subscribe(
      (resp: ProductAuthResponse) => {
        if (resp.responseCode === "200") {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: resp.responseMessage,
          });
          this.fakeFeedbackForm.reset();
          this.onHiddenFakeFeedbackForm();
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Oops",
            detail: resp.responseMessage,
          });
        }
      },
      (err) => {},
    );
  }
  get fakeForm() {
    return this.fakeFeedbackForm.controls;
  }
  handleFakeFeedImage(event) {
    if (event) {
      if (event.files) {
        if (event.files.length > 0) {
          this.fakeFeedbackForm.controls["verImg"].clearValidators();
          this.fakeFeedbackForm.controls["verImg"].setErrors(null);
          this.fakeFeedbackForm.controls["verImg"].setValidators(null);

          this.fakeFeedbackForm.value.verImg = event.files[0];
          this.fakeFeedbackImage = event.files[0];
        }
      }
    }
  }
  resetFeedbackForm() {
    this.feedbackForm.reset();
    const obj = this.f;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
    this.submitted = false;
  }
  resetFakeFeedbackForm() {
    this.fakeFeedbackForm.reset();
    const obj = this.fakeForm;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
    this.isFakeFeedbackSubmitted = false;
  }
  hideVerificationHistory() {
    this.showVerficationHistory = false;
  }
  handleScanHistory() {
    const verificationHistories = localStorage.verificationHistories
      ? JSON.parse(localStorage.verificationHistories)
      : [];
    if (verificationHistories.length > 0) {
      const req = { first: 0, pageNo: 0, pageSize: -1, verificationHistories };
      this.getVerificationHistory(req);
    }
    this.showVerficationHistory = true;
  }
  getVerificationHistory(verificationHistories: any) {
    this.prodAuthService
      .getVerificationHistory(verificationHistories)
      .subscribe(
        (resp: GetUserVerificationResponse) => {
          if (resp.responseCode === "200") {
            this.verificationHistory = resp.data;
          } else {
          }
        },
        (err) => {},
      );
  }

  omit_special_char(event) {
    var k;
    k = event.charCode; // k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  parse_query_string(url_string: any) {
    var url = new URL(url_string);
    var c = url.searchParams.get("uid");
    //console.log(c);
    return c;
  }

  redeemLoyalty() {
    sessionStorage.setItem("prodDetails", JSON.stringify(this.prodDetails));
    this.router.navigateByUrl("/redeem-loyalty", {
      state: {
        seqNo: this.prodDetails.data.seqNo,
        compId: this.prodDetails.data.compId,
        points: this.prodDetails.data.points,
        qrData: window.location.href,
        verificationId: this.prodDetails.data.verificationId,
        prefix: this.prodDetails.data.prefix,
        isUPI: this.prodDetails.data.easebuzz_UPI,
        isBank: this.prodDetails.data.easebuzz_Bank,
        isPaytm: this.prodDetails.data.easebuzz_Paytm,
      },
    });
  }

  onCountrySelect(event: any): void {
    this.askDetailForm.patchValue({
      mobNo: "",
    });
  }
}
